import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.396 11.677a1.135 1.135 0 0 0 1.605 0l2.982-2.982a1.135 1.135 0 0 0 0-1.605L12 4.109a1.135 1.135 0 1 0-1.605 1.605l1.043 1.043H1.605a1.135 1.135 0 0 0 0 2.27h9.834l-1.043 1.044a1.135 1.135 0 0 0 0 1.606",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }